<template>
    <div class="projectCase">
        <div v-if="banner && banner.length" class="projectCase-banner">
            <img :src="img.logo" v-for="img in banner" :key="img.logo" alt="" @click="openBanner(img.url)" />
        </div>
        <div class="projectCase-body">
            <div class="projectCase-tabs">
                <!-- <template v-for='(tab, key) in tabs'>
                  <Tabs 
                      :tabsList="tab" 
                      :key="key" 
                      :tabKey="key" 
                      :activeType="activeTab[key]" 
                      @handleTab="handleTab" />
              </template> -->
                <el-tabs v-model="tabName" @tab-click="setTabPane(tabName)">
                    <el-tab-pane :label="item.categoryName" v-for="item in tabList" :name="`${item.categoryId}`">
                        <svg-icon v-if="item.newStatus === 1" icon-class="new" class-name="icon-new-top"></svg-icon>
                        <div class="tab-item" v-if="activeTab.categoryTwo && tabName !== 'null'">
                            行业：
                            <span :class="{ active: activeTab.categoryTwo === `o` }" @click="setCategory(`o`)">全部</span>
                            <span
                                :class="{ active: activeTab.categoryTwo === subItem.categoryId }"
                                @click="setCategory(subItem.categoryId)"
                                v-for="subItem in item.childList"
                                :key="subItem.categoryId"
                            >
                                <svg-icon v-if="subItem.newStatus === 1" icon-class="new" class-name="icon-new"></svg-icon>
                                {{ subItem.categoryName }}
                            </span>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <!-- <el-select size="mini"  v-model="activeTab.sort" @change="handleTab('sort',activeTab.sort)">
              <el-option  label="综合排序" value="1"></el-option>
              <el-option  label="最近更新" value="2"></el-option>
              <el-option  label="最多下载" value="3"></el-option>
              <el-option  label="最多收藏" value="4"></el-option>
              <el-option  label="免费素材" value="5"></el-option>
              <el-option  label="付费素材" value="6"></el-option>
          </el-select>
          <el-select size="mini" style="margin-left:20px;width:140px" v-if="tabName === bigScreenType"  v-model="activeTab.size" @change="handleTab('size',activeTab.size)">
              <el-option  label="全部尺寸" value=""></el-option>
              <el-option v-for="item in sizeList" :key="item.size" :label="item.name" :value="item.size"></el-option>
          </el-select>
          <el-select size="mini" style="margin-left:20px;width:140px" v-model="activeTab.twoSort" @change="handleTab('twoSort',activeTab.twoSort)">
              <el-option  label="价格排序" value=""></el-option>
              <el-option  label="价格由低到高" value="2"></el-option>
              <el-option  label="价格由高到低" value="1"></el-option>
          </el-select> -->
            <!-- 素材列表 -->
            <project-case-list :tab="activeTab" ProjectCaseType="1" />
        </div>
    </div>
</template>

<script>
import { getProjectCaseCategory } from '@/api/projectCase';
import { getBannerURL } from '@/api/common';
import ProjectCaseList from './components/ProjectCaseList';
import Tabs from '@/components/Tabs';

export default {
    name: 'ProjectCase',
    components: {
        ProjectCaseList,
        Tabs,
    },
    data: () => ({
        tabName: '',
        tabs: {
            label: [
                {
                    type: '',
                    title: '全部标签',
                },
            ],
            category: [
                {
                    type: '',
                    title: '全部分类',
                },
            ],
            format: [
                {
                    type: '',
                    title: '全部格式',
                },
            ],
        },
        bigScreenType: '',
        tabList: [],
        formatList: [],
        activeTab: {
            techId: sessionStorage.getItem('project_case_techIdTab') || 'o',
            categoryOne: sessionStorage.getItem('project_case_categoryOneTab') || 'null',
            categoryTwo: sessionStorage.getItem('project_case_categoryTwoTab') || 'o',
            // title: sessionStorage.getItem('project_case_formatTab') || '',
            // size: sessionStorage.getItem('project_case_sizeTab') || '',
            // twoSort: sessionStorage.getItem('project_case_sizeTab') || ''
        },
        sizeList: [],
        topCategory: '',
        banner: '', // banner图地址
    }),
    created() {
        this.topCategory = this.$route.params.type;
        this.tabName = this.$route.params.type;
        debugger;
        if (this.$route.params.subType) {
            this.activeTab.categoryTwo = Number(this.$route.params.subType);
        }
        if (this.$route.params.type) {
            this.activeTab.categoryOne = Number(this.$route.params.type);
        }
    },
    mounted() {
        this.getTabs();
        this.getBannerURL();
        // this.getFormatList();
        // this.getSizeList()
    },
    methods: {
        setTabPane(id) {
            this.$router.replace(`/projectCase/${id}`);
            this.activeTab.categoryTwo = 'o';
            this.activeTab.techId = 'o';
            this.activeTab.categoryOne = id;
            this.topCategory = id;
            this.handleTab('categoryOne', id);
            this.handleTab('categoryTwo', 'o');
            this.handleTab('techId', 'o');
        },
        setCategory(id) {
            this.$router.replace(`/projectCase/${this.topCategory}/${id}`);
            this.activeTab.categoryTwo = id;
            this.handleTab('categoryTwo', id);
        },
        setTech(id) {
            this.activeTab.techId = id;
            this.handleTab('techId', id);
        },
        openBanner(imgUrl) {
            window.open(imgUrl);
        },
        async getFormatList() {
            try {
                const { data: formatList } = await getAllFormat();
                this.formatList = formatList || [];
            } catch (error) {
                console.log('error: ', error);
            }
        },
        async getSizeList() {
            try {
                const { data: sizeList } = await getSizeList();
                this.sizeList = sizeList || [];
            } catch (error) {
                console.log('error: ', error);
            }
        },
        // 获取banner图地址
        getBannerURL() {
            getBannerURL(10).then(({ data }) => {
                this.banner = (data || []).splice(0, 2);
            });
        },
        getTabs() {
            // for (let key in this.tabs) {
            //     METHODS[`getProjectCase${key.charAt(0).toUpperCase() + key.slice(1)}List`]().then(({ data }) => {
            //         const transformData = data.map(item => ({
            //             type: item.id,
            //             title: item.name,
            //             newStatus: item.newStatus
            //         }));

            //         this.tabs[key].push(...transformData);
            //     });
            // }
            getProjectCaseCategory().then((res) => {
                const list = res.data || [];
                this.tabList = list;
                // this.bigScreenType = (list.find(item => item.name === '大屏模板') || {}).id + ''
                if (!this.$route.params.type) {
                    this.tabName = list.length ? `${list[0].categoryId}` : '0';
                }
                if (!this.activeTab.categoryOne) {
                    this.activeTab.categoryOne = this.tabName;
                }
            });
        },
        handleTab(type, key) {
            sessionStorage.setItem(`project_case_${type}Tab`, key);
            sessionStorage.setItem(this.$route.path, 1);
        },
    },
};
</script>

<style lang="scss" scoped>
.projectCase {
    &-tabs {
        padding-bottom: 10px;
        margin-bottom: 10px;
        .base-tabs {
            // margin-bottom: 20px;
        }
    }
    &-banner {
        // padding: 20px 0;
        // background-color: #fff;
        text-align: center;
        font-size: 0;
        display: flex;
        padding: 20px 0 0 0;
        width: 1600px;
        overflow: hidden;
        margin: 0 auto;
        > img {
            cursor: pointer;
            flex: 1;
            margin-right: 20px;
            border-radius: 4px;
            height: 120px;
            font-size: 0;
            width: 790px;
            &:nth-last-child(1) {
                margin-right: 0;
            }
        }
    }

    &-body {
        margin: 0 auto;
        padding-top: 20px;
        width: 1600px;
        /deep/ .el-tabs__content {
            overflow: visible;
        }
        /deep/ .el-tabs__item {
            font-size: 16px;
            color: #272c40;
            &:hover {
                color: #2c54ef;
            }
            &.is-active {
                color: #2c54ef;
                font-weight: 600;
            }
        }
        /deep/ .el-select {
            width: 110px;
            input {
                font-size: 14px;
            }
        }
        .icon-new-top {
            position: absolute;
            right: 0px;
            top: 0px;
        }
        /deep/ .el-input__inner {
            background: #f5f6f9;
        }
    }
    .tab-item {
        margin-bottom: 9px;
        color: #a4a7b4;
        font-size: 16px;
        span {
            margin-right: 20px;
            padding: 3px 8px;
            display: inline-block;
            color: #272c40;
            font-size: 16px;
            cursor: pointer;
            position: relative;
            &:hover {
                color: #2c54ef;
            }
            &.active {
                color: #2f54eb;
                background: #dce3fd;
                border-radius: 4px;
            }
            .icon-new {
                position: absolute;
                right: 0px;
                top: -10px;
            }
        }
    }
}

// 小屏
@include mq($small) {
    .projectCase {
        &-banner {
            width: 1200px;
        }
        &-body {
            width: 1200px;
        }
        &-tabs {
            padding-bottom: 4px;
            .base-tabs {
                margin-bottom: 14px;
            }
        }
    }
}
</style>
